angular.module('impactx.purchaseorder').controller('PurchaseOrderAddressRelatedListCtrl', [
    'selectedListItems',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    '$redirect',
    'OneTimeDataTransporter',
    PurchaseOrderAddressRelatedListCtrl]);

function PurchaseOrderAddressRelatedListCtrl(selectedListItems, dataGen, $mdDialog, TranslationService, $redirect, OneTimeDataTransporter) {
    var ctrl = this;
    this.getDetailsLink = function () {
        return "purchaseorderdetail/" + selectedListItems.getFirstSelectedId();
    };

    ctrl.isGRNTotalPossible = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canGRNTotal.value;
    };

    ctrl.editGRNTotal = function () {
        var tempScope = {};
        var selected = selectedListItems.getSelectedItems().map(function(entry) {return {id: entry.id, pohId: entry.id}});
        dataGen.getData(tempScope, {selected: [selected]}, "/deliverynote/purchaseorderlist/viewHead").then(function () {
            $mdDialog.show({
                templateUrl: "modules/deliverynote/templates/deliverynote-total.tmpl.html",
                controller: "DeliveryNoteTotalCtrl",
                controllerAs: "deliveryNoteTotalCtrl",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    withSerialNumber: true,
                    data: tempScope.data,
                    trns: tempScope.trns,
                    count: selectedListItems.getFirstSelectedItem().pos_count,
                    sum: selectedListItems.getFirstSelectedItem().amount
                }
            });
        });
    };

    this.checkMultiDelNote = function (event, trns) {
        var multiOk = true;
        var selected = selectedListItems.getSelectedItems();
        if (selected.length > 1) {
            for (var i = 0; i < selected.length; i++) {
                if (!selected[i].multiplePOHForDNHAllowed || !selected[i].multiplePOHForDNHAllowed.value) {
                    multiOk = false;
                    break;
                }
            }
        }
        if (multiOk) {
            $redirect.redirectTo(null, "/deliverynote");
        }
        else {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .textContent(trns.multiplePOHError)
                    .ariaLabel('Alert Dialog')
                    .ok(TranslationService.get('ok'))
            );
        }
    };

    this.showCreateDelNoteButton = function () {
        return selectedListItems.isMultiSelection() && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.complaintMessage = function (event, trns) {
        var data = {
            subject: trns.complaintMessageSubject.replace("^0", selectedListItems.getFirstSelectedItem().orderNos.orderNumbers[0]),
            recipients: selectedListItems.getFirstSelectedItem().complaintMessageRecipients.entries,
            postSentEndpoint: "/purchaseorder/markComplaintMessageSentForOrder",
            postSentEndpointParams: {pohId : selectedListItems.getFirstSelectedItem().id},
            submitMessage: true,
            messageRoute: "purchaseorderdetail",
            messageRouteId: selectedListItems.getFirstSelectedItem().id
        };
        OneTimeDataTransporter.setAndRedirect(data, trns, "/message/0");
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getDetailsLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderView'
        },
        {
            label: "complaint",
            type: 'dialogaction',
            action: ctrl.complaintMessage,
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderView'
        },
        {
            label: "grnTotal",
            action: ctrl.editGRNTotal,
            condition: ctrl.isGRNTotalPossible,
            process: 'EditDeliveryNote'
        },
        {
            label: "createDelNote",
            action: ctrl.checkMultiDelNote,
            condition: ctrl.showCreateDelNoteButton,
            process: 'EditDeliveryNote'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/purchaseorder/templates/purchaseorderaddressrelatedlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaseorder/listaddressrelated',
        ctrl: this,
        id: "purchaseorderaddressrelatedlist",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}